<template>
  <div v-show="visible">
      <label>I want to instruct {{trustee}} to</label>
      <div v-for="option in options" class="radio radio-primary">
        <input type="radio" :id="option.value" name="registration_account" :value="option.value" :checked="option.value === account" v-model="account" @change="accountOptionChanged($event)"/>
        <label v-if="option.value === 'rrsp_existing'">{{ option.label + trustee + ' account' }}</label>
        <label v-if="option.value === 'rrsp_new'">{{ option.label }}</label>
      </div>
  </div>
</template>

<script>

export default {
  props : {
    registeredDefaults: { type: Object }
  },
  data() {
    return {
      visible : false,
      name: 'registration_account',
      options: [
          {label : 'open a new account for me to make the investment', value : 'rrsp_new'},
          {label : 'make the investment in my existing ', value : 'rrsp_existing'}
       ],
      status: this.registeredDefaults.status,
      trustee: this.registeredDefaults.trustee,
      account : this.registeredDefaults.account,
      optionSelected: '',
    }
  },
  created() {
    this.visible = this.status !== 'cash' && this.status !== ''
    this.$root.$on('trusteeChanged', this.onTrusteeChanged);
  },
  methods : {
    onTrusteeChanged(trustee) {
      this.trustee = trustee.name
      this.status = trustee.value
      if(trustee.value === 'cash') {
        this.account = ''
        this.trustee = ''
        this.$root.$emit('accountOptionChanged',{'value':event.target.value, 'name': this.name, 'trustee': '' })
      }
      this.visible = trustee.value !== 'cash'
    },
    accountOptionChanged(event) {
      this.$root.$emit('accountOptionChanged',{'value':event.target.value, 'name': this.name, 'trustee': this.trustee })
      this.optionSelected = event.target.value
    }
  },
}
</script>